import moment from 'moment';
import { utils } from '@sfaas/util';

class DaemonModel {
	constructor(daemon) {
		Object.assign(this, daemon);
		const { heartDt, cts, sts } = daemon;
		this.heartDt = !utils.$sf_isNull(heartDt) && !utils.isUndefined(heartDt) ? moment(heartDt).format('YYYY-MM-DD HH:mm:ss') : heartDt;
		this.procStatus = this.procStatusConverter(cts, sts);
	}

	procStatusConverter = (cts, sts) => {
		if (cts === '1' && sts === '1') {
			return 'normal';
		} else if (cts === '0' && sts === '0') {
			return 'stop';
		} else if (cts === '0' && sts === '1') {
			return 'warning';
		} else if (cts === '1' && sts === '0') {
			return 'error';
		} else {
			return 'error';
		}
	};
}

export default DaemonModel;
